"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = WeeklyMeetingActive;
var React = _interopRequireWildcard(require("react"));
var _internal = require("@aws-amplify/ui-react/internal");
var _EntitiyDetail = _interopRequireDefault(require("./EntitiyDetail"));
var _uiReact = require("@aws-amplify/ui-react");
var _BalancePaid = _interopRequireDefault(require("./BalancePaid"));
var _ListClientAsesor = _interopRequireDefault(require("./ListClientAsesor"));
var _ListClientGerente = _interopRequireDefault(require("./ListClientGerente"));
var _AddMediaSuccess = _interopRequireDefault(require("./AddMediaSuccess"));
var _excluded = ["overrides"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function WeeklyMeetingActive(props) {
  var overrides = props.overrides,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "10px",
    direction: "row",
    width: "360px",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    padding: "0px 0px 0px 0px",
    backgroundColor: "rgba(239,240,240,1)"
  }, (0, _internal.getOverrideProps)(overrides, "WeeklyMeetingActive"), rest), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "12px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    grow: "1",
    shrink: "1",
    basis: "0",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 20972")), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "6px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 20986")), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "10px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "HeaderGroup")), /*#__PURE__*/React.createElement(_EntitiyDetail.default, _extends({
    display: "flex",
    gap: "10px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "8px 8px 8px 8px",
    backgroundColor: "rgba(255,255,255,1)"
  }, (0, _internal.getOverrideProps)(overrides, "EntitiyDetail")))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "10px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "WeeksGroup")), /*#__PURE__*/React.createElement(_BalancePaid.default, _extends({
    display: "flex",
    gap: "8px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "center",
    alignItems: "center",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "10px 8px 18px 8px",
    backgroundColor: "rgba(255,255,255,1)",
    state: "Success"
  }, (0, _internal.getOverrideProps)(overrides, "BalancePaid"))))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "10px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 8px 0px 8px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 20984")), /*#__PURE__*/React.createElement(_uiReact.Heading, _extends({
    width: "unset",
    height: "unset",
    shrink: "0",
    alignSelf: "stretch",
    level: "5",
    children: "Integrantes"
  }, (0, _internal.getOverrideProps)(overrides, "Heading")))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "21px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "center",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 20px 0px",
    backgroundColor: "rgba(255,255,255,1)"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 9756")), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "0",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 8")), /*#__PURE__*/React.createElement(_ListClientAsesor.default, _extends({
    display: "flex",
    gap: "8px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "8px 8px 0px 8px",
    backgroundColor: "rgba(255,255,255,1)"
  }, (0, _internal.getOverrideProps)(overrides, "ListClient/Asesor"))), /*#__PURE__*/React.createElement(_ListClientGerente.default, _extends({
    display: "flex",
    gap: "8px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "8px 8px 0px 8px",
    backgroundColor: "rgba(255,255,255,1)"
  }, (0, _internal.getOverrideProps)(overrides, "ListClient/Gerente")))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "24px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "center",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 12px 0px 12px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 20973")), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "10px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "FrameAddMedia")), /*#__PURE__*/React.createElement(_AddMediaSuccess.default, _extends({
    display: "flex",
    gap: "24px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "center",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "AddMediaSuccess")))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "10px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "btnEnviarReporte")), /*#__PURE__*/React.createElement(_uiReact.Button, _extends({
    width: "unset",
    height: "unset",
    shrink: "0",
    alignSelf: "stretch",
    size: "default",
    isDisabled: false,
    variation: "primary",
    children: "ENVIAR REPORTE"
  }, (0, _internal.getOverrideProps)(overrides, "Button"))))))));
}